import { Component, Input } from '@angular/core';
import { FiltersComponent } from 'src/app/common/filters.component';

@Component({
	selector: 'app-resident-base-trip-list-filter',
	templateUrl: './resident-base-trip-list-filter.component.html',
	styleUrls: ['./resident-base-trip-list-filter.component.css'],
})
export class ResidentBaseTripListFilterComponent extends FiltersComponent {
	@Input() destinations: Array<any> = [];
	filters = {
		destination: null,
	};
}
